import React from 'react';

import {
  object, number, string
} from 'yup';

import FormResource from './FormResource.jsx';
import FormGroup from '~/commons/components/FormGroup.jsx';

const defaults = {
  address: '',
  owner: '',
  player: '',
  horse: '',
  profitShare: 0,
  status: '',
};

const FormShare = ({
  share,
}) => (
  <FormResource
    {...{
      defaults,
      schema: object({
        profitShare: number().min(0),
      }),
      stored: share,
      api: '/api/site/shares',
      options: {omitIds: false},
    }}
  >
    <div className="form-row">
      <div className="col">
      <FormGroup name="status" label="Status" disabled/>
      </div>
      <div className="col">
      <FormGroup name="address" label="Address" disabled/>
      </div>
      <div className="col">
      <FormGroup name="profitShare" label="Profit Share" disabled/>  
      </div>
    </div>

    <div className="form-row">
      <div className="col">
      <FormGroup name="horse.name" label="Horse Name" disabled/>
      </div>
      <div className="col">
      <FormGroup name="horse.clsLv" label="Horse Class" disabled/>  
      </div>
    </div>

    <div className="form-row">
      <div className="col">
      <FormGroup name="creator" disabled/>
      </div>
      <div className="col">
      <FormGroup name="player" disabled/>
      </div>
    </div>

  </FormResource>
);

export default FormShare;
